/**
 * One-writer catalog for person facts (care-delivery IA S4 / S5).
 *
 * Tests assert the rule — each input id exists once across the standing
 * editors — rather than pinning a paragraph of copy in one file.
 */

export const HOW_WE_CARE_ANCHOR = 'how-we-care';

export const WHO_TO_CALL_ANCHOR = 'who-to-call';

export const NETWORK_INPUT_IDS = [
  'people-network-gp-name',
  'people-network-gp-clinic',
  'people-network-gp-phone',
  'people-network-gp-provider',
  'people-network-pharmacy-name',
  'people-network-pharmacy-phone',
] as const;

export const CLINICAL_RISK_INPUT_ID = 'clinical-risk-level';

export const HOW_WE_CARE_INPUT_IDS = [
  'how-we-care-communication-needs',
  'how-we-care-interpreter',
  'how-we-care-language',
  'how-we-care-languages',
  'how-we-care-gender-preference',
  'how-we-care-religion',
  'how-we-care-culture',
  'how-we-care-country',
  'how-we-care-life-story',
  'how-we-care-diet-notes',
] as const;

export type HowWeCareInputId = (typeof HOW_WE_CARE_INPUT_IDS)[number];

/** Identity fields added in S5. Existing name/contact/address ids stay. */
export const IDENTITY_S5_INPUT_IDS = [
  'edit-profile-pronouns',
  'edit-profile-indigenous-status',
] as const;

export const IDENTITY_CORE_INPUT_IDS = [
  'edit-profile-first-name',
  'edit-profile-last-name',
  'edit-profile-preferred-name',
  'edit-profile-pronouns',
  'edit-profile-gender',
  'edit-profile-dob',
  'edit-profile-mobile-phone',
  'edit-profile-home-phone',
  'edit-profile-email',
  'edit-profile-indigenous-status',
] as const;

/**
 * Standing editor surfaces that may write `clients.*` person facts.
 * A field claimed editable must have exactly one `id="…"` across these.
 */
export const PERSON_FACT_WRITER_SURFACES = [
  'apps/web/src/app/(dashboard)/clients/[id]/_components/ClientHowWeCarePanel.tsx',
  'apps/web/src/app/(dashboard)/clients/[id]/_components/ClientNetworkPanel.tsx',
  'apps/web/src/app/(dashboard)/clients/[id]/_components/ClientClinicalSnapshotTab.tsx',
  'apps/web/src/app/(dashboard)/clients/[id]/ClientProfileWorkstation.tsx',
  'apps/web/src/components/care-plans/ClinicalContextSection.tsx',
] as const;

export const HOW_WE_CARE_WRITER_SURFACE =
  'apps/web/src/app/(dashboard)/clients/[id]/_components/ClientHowWeCarePanel.tsx';

export const CLINICAL_WRITER_SURFACE =
  'apps/web/src/app/(dashboard)/clients/[id]/_components/ClientClinicalSnapshotTab.tsx';

export const IDENTITY_WRITER_SURFACE =
  'apps/web/src/app/(dashboard)/clients/[id]/ClientProfileWorkstation.tsx';
